<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Détails des agents</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <!--<modal :adaptive=true
                       :clickToClose="false"
                       :draggable=true
                       :resizable=true
                       height="auto"
                       name="modal-fade">-->
        <v-dialog max-width="650px" persistent v-model="dialog2">
          <v-card>
            <v-toolbar
                color="primary"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            readonly
                            rounded
                            v-model="modifier">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                  @click="hide()"
                  dark
                  fab
                  small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-alert :color=AlertColorS(typeS)
                       :dismissible=true
                       :value=true
                       border="top"
                       class="pre-formatted multi-line"
                       colored-border
                       elevation="2"
                       icon="check_circle"
                       v-if="typeS">
                {{ text }}
              </v-alert>
              <v-container>
                <v-card-text>
                  <v-container height="600">
                    <v-stepper v-model="e6" vertical>
                      <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                        Statut
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-row class="justify-center align-center">
                          <v-col md="6" sm="6">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          disabled
                                          label="Matricule agent"
                                          prepend-inner-icon="mdi-human-male"
                                          v-model="editedItem.userId">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-select :items="genre"
                                      class="centered-input align-center text-center"
                                      item-text="type" item-value="type"
                                      label="Genre"
                                      prepend-inner-icon="mdi-gender-male-female"
                                      v-model="editedItem.genre">
                              <template v-slot:selection="{ item }">
                                                              <span class="d-flex justify-center" style="width: 100%;">
                                                                {{ item }}
                                                              </span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-select :items="status"
                                      class="centered-input align-center text-center"
                                      item-text="type" item-value="type"
                                      label="Statut"
                                      prepend-inner-icon="mdi-account-question-outline"
                                      v-model="editedItem.status">
                              <template v-slot:selection="{ item }">
                                                              <span class="d-flex justify-center" style="width: 100%;">
                                                                {{ item }}
                                                              </span>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Religion"
                                          prepend-inner-icon="mdi-apple-keyboard-option"
                                          v-model="editedItem.religion">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          hide-details
                                          label="Nombre enfants"
                                          prepend-inner-icon="mdi-account-child-outline"
                                          type="number"
                                          v-model="editedItem.nbrEnfants">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date naissance"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormatted"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu= false"
                                  locale="fr-FR"
                                  prepend-inner-icon="mdi-cake"
                                  v-model="editedItem.birthdayDate"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Lieu naissance"
                                          prepend-inner-icon="mdi-select-place"
                                          v-model="editedItem.birthdayPlace">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 2" class="mb-2"
                               color="primary"><span
                            class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                      <v-stepper-step :complete="e6 > 2" :editable="true"
                                      step="2">Contrat
                      </v-stepper-step>
                      <v-stepper-content step="2">
                        <v-row class="justify-center align-center">
                          <v-col md="6" sm="6">
                            <v-select :items="typescontract"
                                      class="centered-input align-center text-center"
                                      item-text="type" item-value="type"
                                      label="Type contrat"
                                      prepend-inner-icon="mdi-alpha-c-circle-outline"
                                      v-model="editedItem.typecontract">
                              <template v-slot:selection="{ item }">
                                                              <span class="d-flex justify-center" style="width: 100%;">
                                                                {{ item }}
                                                              </span>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu2"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date début contrat"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormattedSCD"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu2= false"
                                  locale="fr-FR"
                                  v-model="editedItem.startContractDate"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu3"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date fin contrat"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormattedECD"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu3= false"
                                  locale="fr-FR"
                                  v-model="editedItem.endContractDate"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center align-center">
                          <v-col md="6" sm="6">
                            <v-select :items="reasonsleave"
                                      class="centered-input align-center text-center"
                                      item-text="type" item-value="type"
                                      label="Raison départ"
                                      prepend-inner-icon="mdi-location-exit"
                                      v-model="editedItem.reasonLeft">
                              <template v-slot:selection="{ item }">
                                                              <span class="d-flex justify-center" style="width: 100%;">
                                                                {{ item }}
                                                              </span>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center align-center">
                          <v-col cols="12" md="6" sm="6">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu4"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date réel départ"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormattedDRD"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu4= false"
                                  locale="fr-FR"
                                  v-model="editedItem.dateRealLeft"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 3" class="mb-2" color="primary">
                          <span class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                      <v-stepper-step :complete="e6 > 3" :editable="true" step="3">
                        Liste certifications
                      </v-stepper-step>
                      <v-stepper-content step="3">
                        <v-card flat>
                          <v-card-text>
                            <v-row class="justify-center align-center">
                              <v-col cols="12" md="9" sm="12">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Certifications"
                                              prepend-inner-icon="mdi-paper-cut-vertical"
                                              v-model="editedItem.certifications">
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row class="justify-center align-center">
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    label="X-Ray"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="xray"
                                ></v-switch>
                              </v-col>
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    input-value="false"
                                    label="OJT X-Ray"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="oxray"
                                ></v-switch>
                              </v-col>
                            </v-row>
                            <v-row class="justify-center align-center">
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    label="Bag. soute & cabine"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="bsc"
                                ></v-switch>
                              </v-col>
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    label="Filt. pers. & objets"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="fpo"
                                ></v-switch>
                              </v-col>
                            </v-row>
                            <v-row class="justify-center align-center">
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    label="Filt. frêt & poste"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="ffp"
                                ></v-switch>
                              </v-col>
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    label="Fouille ctrl. véh."
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="fcv"
                                ></v-switch>
                              </v-col>
                            </v-row>
                            <v-row class="justify-center align-center">
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    input-value="false"
                                    label="OJT Base"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="obase"
                                ></v-switch>
                              </v-col>
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    input-value="false"
                                    label="Formé(e)"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="f"
                                ></v-switch>
                              </v-col>
                            </v-row>
                            <v-row class="justify-center align-center">
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    input-value="false"
                                    label="MDR"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="mdr"
                                ></v-switch>
                              </v-col>
                              <v-col cols="12" md="6" sm="12">
                                <v-switch
                                    input-value="false"
                                    label="Sensibilisé(e)"
                                    prepend-inner-icon="mdi-hand-pointing-right"
                                    v-model="bCertifications"
                                    value="s"
                                ></v-switch>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        <v-btn @click="e6 = 4" class="mb-2" color="primary">
                          <span class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                      <v-stepper-step :complete="e6 > 4" :editable="true" step="4">
                        Date certifications
                      </v-stepper-step>
                      <v-stepper-content step="4">
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu8"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date Certif X-Ray"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormattedXRay"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu8= false"
                                  locale="fr-FR"
                                  v-model="editedItem.dateCertifXRay"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu5"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date Certif Base"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormattedBase"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu5= false"
                                  locale="fr-FR"
                                  v-model="editedItem.dateCertifBase"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu6"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date Certif MDR"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormattedMDR"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu6= false"
                                  locale="fr-FR"
                                  v-model="editedItem.dateMDR"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="menu7"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :id="dynamicID()"
                                              class="centered-input align-center"
                                              label="Date Formation"
                                              persistent-hint
                                              prepend-inner-icon="mdi-calendar"
                                              readonly
                                              v-bind="attrs"
                                              v-model="computedDateFormattedFormed"
                                              v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  @input="menu7= false"
                                  locale="fr-FR"
                                  v-model="editedItem.dateFormed"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 5" class="mb-2" color="primary">
                          <span class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                      <v-stepper-step :complete="e6 > 5" :editable="true" step="5">
                        Autres infos
                      </v-stepper-step>
                      <v-stepper-content step="5">
                        <v-row class="justify-center align-center">
                          <v-col cols="12" md="9" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Autres formations"
                                          prepend-inner-icon="mdi-book-information-variant"
                                          v-model="editedItem.otherFormations">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center align-center">
                          <v-col cols="12" md="6" sm="12">
                            <v-select :items="levels"
                                      class="centered-input align-center text-center"
                                      item-text="type" item-value="type"
                                      label="Niveau formation"
                                      prepend-inner-icon="mdi-spirit-level"
                                      v-model="editedItem.level">
                              <template v-slot:selection="{ item }">
                                                              <span class="d-flex justify-center" style="width: 100%;">
                                                                {{ item }}
                                                              </span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-select :items="buslines"
                                      class="centered-input align-center text-center"
                                      item-text="type" item-value="type"
                                      label="Ligne bus"
                                      prepend-inner-icon="mdi-bus"
                                      v-model="editedItem.busline">
                              <template v-slot:selection="{ item }">
                                                              <span class="d-flex justify-center" style="width: 100%;">
                                                                {{ item }}
                                                              </span>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center align-center">
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Arrêt bus"
                                          prepend-inner-icon="mdi-bus-stop"
                                          v-model="editedItem.busStop">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Taille agent (cm)"
                                          prepend-inner-icon="mdi-human-male-height-variant"
                                          v-model="editedItem.taille">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center align-center">
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Pointure"
                                          prepend-inner-icon="mdi-shoe-sneaker"
                                          v-model="editedItem.pointure">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Taille chemise"
                                          prepend-inner-icon="mdi-tshirt-crew-outline"
                                          v-model="editedItem.tailleChemise">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center align-center">
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Taille jupe"
                                          prepend-inner-icon="mdi-human-female"
                                          v-model="editedItem.tailleJupe">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Taille pantalon"
                                          prepend-inner-icon="mdi-human-male"
                                          v-model="editedItem.taillePantalon">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 5" class="mb-2" color="primary">
                          <span class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                    </v-stepper>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                         class="white--text"
                         color="#01579B" depressed>Modifier détails
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-card class="mt-1" flat
                tile>
          <v-row justify="center">
            <v-dialog
                max-width="290"
                v-model="dialogTmp">
              <v-card fill-height>
                <v-img :src="getImgUrl(namePhoto)" contains/>
              </v-card>
            </v-dialog>
          </v-row>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexportModele" block
                     class="custom-btn white--text"
                     color="#03A9F4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span> Export modèle </span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export détails</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="650px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="init()" block
                         class="custom-btn white--text"
                         color="#009688" height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span> Création détails </span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                    <v-tab href="#tab-2"> Via un fichier excel</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-stepper v-model="e6" vertical>
                            <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                              Statut
                            </v-stepper-step>
                            <v-stepper-content step="1">
                              <v-row class="justify-center align-center">
                                <v-col md="6" sm="6">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Matricule agent"
                                                prepend-inner-icon="mdi-human-male"
                                                v-model="editedItem.userId">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6" sm="6">
                                  <v-select :items="genre"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Genre"
                                            prepend-inner-icon="mdi-gender-male-female"
                                            v-model="editedItem.genre">
                                    <template v-slot:selection="{ item }">
                                                                          <span class="d-flex justify-center"
                                                                                style="width: 100%;">
                                                                            {{ item }}
                                                                          </span>
                                    </template>
                                  </v-select>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-select :items="status"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Statut"
                                            prepend-inner-icon="mdi-account-question-outline"
                                            v-model="editedItem.status">
                                    <template v-slot:selection="{ item }">
                                                                          <span class="d-flex justify-center"
                                                                                style="width: 100%;">
                                                                            {{ item }}
                                                                          </span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Religion"
                                                prepend-inner-icon="mdi-apple-keyboard-option"
                                                v-model="editedItem.religion">
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                hide-details
                                                label="Nombre enfants"
                                                type="number"
                                                v-model="editedItem.nbrEnfants">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date naissance"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormatted"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu= false"
                                        locale="fr-FR"
                                        prepend-inner-icon="mdi-cake"
                                        v-model="editedItem.birthdayDate"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Lieu naissance"
                                                prepend-inner-icon="mdi-select-place"
                                                v-model="editedItem.birthdayPlace">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-btn @click="e6 = 2" class="mb-2"
                                     color="primary"><span
                                  class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 2" :editable="true"
                                            step="2">Contrat
                            </v-stepper-step>
                            <v-stepper-content step="2">
                              <v-row class="justify-center align-center">
                                <v-col md="6" sm="6">
                                  <v-select :items="typescontract"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Type contrat"
                                            prepend-inner-icon="mdi-alpha-c-circle-outline"
                                            v-model="editedItem.typecontract">
                                    <template v-slot:selection="{ item }">
                                                                          <span class="d-flex justify-center"
                                                                                style="width: 100%;">
                                                                            {{ item }}
                                                                          </span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu2"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date début contrat"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormattedSCD"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu2= false"
                                        locale="fr-FR"
                                        v-model="editedItem.startContractDate"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu3"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date fin contrat"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormattedECD"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu3= false"
                                        locale="fr-FR"
                                        v-model="editedItem.endContractDate"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center align-center">
                                <v-col md="6" sm="6">
                                  <v-select :items="reasonsleave"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Raison départ"
                                            prepend-inner-icon="mdi-location-exit"
                                            v-model="editedItem.reasonLeft">
                                    <template v-slot:selection="{ item }">
                                                                          <span class="d-flex justify-center"
                                                                                style="width: 100%;">
                                                                            {{ item }}
                                                                          </span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="6">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu4"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date réel départ"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormattedDRD"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu4= false"
                                        locale="fr-FR"
                                        v-model="editedItem.dateRealLeft"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                              <v-btn @click="e6 = 3" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 3" :editable="true" step="3">
                              Liste certifications
                            </v-stepper-step>
                            <v-stepper-content step="3">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col cols="12" md="9" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Certifications"
                                                    prepend-inner-icon="mdi-paper-cut-vertical"
                                                    v-model="editedItem.certifications">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row class="justify-center align-center">
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          label="X-Ray"
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="xray"
                                      ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          input-value="false"
                                          label="OJT X-Ray"
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="oxray"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                  <v-row class="justify-center align-center">
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          label="Bag. soute & cabine"
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="bsc"
                                      ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          label="Filt. pers. & objets"
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="fpo"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                  <v-row class="justify-center align-center">
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          label="Filt. frêt & poste"
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="ffp"
                                      ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          label="Fouille ctrl. véh."
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="fcv"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                  <v-row class="justify-center align-center">
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          input-value="false"
                                          label="OJT Base"
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="obase"
                                      ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-switch
                                          input-value="false"
                                          label="MDR"
                                          prepend-inner-icon="mdi-hand-pointing-right"
                                          v-model="bCertifications"
                                          value="mdr"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 4" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 4" :editable="true" step="4">
                              Date certifications
                            </v-stepper-step>
                            <v-stepper-content step="4">
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu8"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date Certif X-Ray"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormattedXRay"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu8= false"
                                        locale="fr-FR"
                                        v-model="editedItem.dateCertifXRay"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu5"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date Certif Base"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormattedBase"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu5= false"
                                        locale="fr-FR"
                                        v-model="editedItem.dateCertifBase"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu6"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date Certif MDR"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormattedMDR"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu6= false"
                                        locale="fr-FR"
                                        v-model="editedItem.dateMDR"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-menu
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      min-width="290px"
                                      offset-y
                                      transition="scale-transition"
                                      v-model="menu7"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Date Formation"
                                                    persistent-hint
                                                    prepend-inner-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="computedDateFormattedFormed"
                                                    v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        @input="menu7= false"
                                        locale="fr-FR"
                                        v-model="editedItem.dateFormed"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                              <v-btn @click="e6 = 5" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 5" :editable="true" step="5">
                              Autres infos
                            </v-stepper-step>
                            <v-stepper-content step="5">
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="9" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Autres formations"
                                                prepend-inner-icon="mdi-book-information-variant"
                                                v-model="editedItem.otherFormations">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="12">
                                  <v-select :items="levels"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Niveau formation"
                                            prepend-inner-icon="mdi-spirit-level"
                                            v-model="editedItem.level">
                                    <template v-slot:selection="{ item }">
                                                                          <span class="d-flex justify-center"
                                                                                style="width: 100%;">
                                                                            {{ item }}
                                                                          </span>
                                    </template>
                                  </v-select>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-select :items="buslines"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Ligne bus"
                                            prepend-inner-icon="mdi-bus"
                                            v-model="editedItem.busline">
                                    <template v-slot:selection="{ item }">
                                                                          <span class="d-flex justify-center"
                                                                                style="width: 100%;">
                                                                            {{ item }}
                                                                          </span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Arrêt bus"
                                                prepend-inner-icon="mdi-bus-stop"
                                                v-model="editedItem.busStop">
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Taille agent (cm)"
                                                prepend-inner-icon="mdi-human-male-height-variant"
                                                v-model="editedItem.taille">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Pointure"
                                                prepend-inner-icon="mdi-shoe-sneaker"
                                                v-model="editedItem.pointure">
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Taille chemise"
                                                prepend-inner-icon="mdi-tshirt-crew-outline"
                                                v-model="editedItem.tailleChemise">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Taille jupe"
                                                prepend-inner-icon="mdi-human-female"
                                                v-model="editedItem.tailleJupe">
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Taille pantalon"
                                                prepend-inner-icon="mdi-human-male"
                                                v-model="editedItem.taillePantalon">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-btn @click="e6 = 5" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                          </v-stepper>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Créer détails
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2"
                               large style="color:#01579B; background-color:#F5F5F5"
                               v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:mediumvioletred;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTable"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import Vue from "vue";

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.type = 'dropdown';

  const physicalColumn = instance.toPhysicalColumn(col);

  if (physicalColumn === 11) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Status")) || [];
  } else if (physicalColumn === 14) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Contracts")) || [];
  } else if (physicalColumn === 17) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("BusLines")) || [];
  } else if (physicalColumn === 39) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Levels")) || [];
  } else if (physicalColumn === 47) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("ReasonsLeave")) || [];
    console.log('Setting source for Raison départ:', cellProperties.source);
  }

  // AJOUT IMPORTANT : Forcer le type dropdown
  if (physicalColumn === 47) {
    cellProperties.allowInvalid = false;
    cellProperties.strict = true;
    cellProperties.trimDropdown = false;
  }
}

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

String.prototype.toSlug = function (str) {
  str = this.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "ãàáäâèéëêìíïîõòóöôùúüûñç·/_,:;";
  var to = "aaaaaeeeeiiiiooooouuuunc------";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

  return str;
};

String.prototype.toSearch = function (query) {
  var str = this.toSlug();

  return this.toSlug().search(new RegExp(query.toLowerCase(), 'i'));
};

function coverRenderer(instance, td, row, col, prop, value, cellProperties) {
  var img;

  img = document.createElement('IMG');
  img.src = value
  img.style.width = "20px";
  img.style.height = "20px";
  img.style.margin = "0 auto";
  img.style.display = "block";

  Handsontable.dom.addEvent(img, 'mousedown', function (e) {
    e.preventDefault(); // prevent selection quirk
  });

  Handsontable.dom.empty(td);
  td.appendChild(img);
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "account_details",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      iconPhoto: "https://www.freeiconspng.com/uploads/camera-icon-search-engine-iconfinder-11.png",
      bCertifications: [],
      status: [],
      buslines: [],
      typescontract: [],
      levels: [],
      reasonsleave: [],
      searchName: "",
      modifier: "",
      dialogTmp: false,
      namePhoto: "",
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      menu: null,
      menu2: null,
      menu3: null,
      menu4: null,
      menu5: null,
      menu6: null,
      menu7: null,
      menu8: null,
      type: null,
      typeS: null,
      elapse: null,
      loading: false,
      loading2: false,
      menustartWorkingDate: false,
      toObject: [],
      editedItem: {
        id: "",
        genre: "",
        status: "",
        userId: "",
        fonction: "",
        accountAddress: "",
        accountPhonenumber: "",
        nbrEnfants: 0,
        religion: "",
        accountFirstname: "",
        accountLastname: "",
        typecontract: "",
        busline: "",
        busStop: "",
        otherFormations: "",
        level: "",
        disabled: false,
        originUser: "",
        creationDate: "",
        birthdayDate: "",
        dateCertifXRay: "",
        dateCertifBase: "",
        dateMDR: "",
        dateFormed: "",
        endContractDate: "",
        startContractDate: "",
        certifications: "",
        birthdayPlace: "",
        taille: "",
        reasonLeft: "",
        dateRealLeft: "",
        pointure: ""
      },
      show1: false,
      e6: 1,
      tab: null,
      dialog: false,
      dialog2: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      genre: ["Homme", "Femme"],
      arrayAbs: [],
      hotSettings: {
        ariaTags: true,
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.displayTitleModif(start.row)
                  window.updateData4Modif(start.row)
                  window.show()
                }, 0);
              }
            },
            sp1: '---------',
            remove_row: {
              name: "Supprimer"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        afterOnCellMouseDown: this.afterOnCellMouseDownMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 13, 22, 28, 29, 31, 32, 34, 36],
          indicators: false
        },

        colHeaders: [
          "Id", "Matricule", "Nom", "Prénom", "Brigade", "Genre", "Fonction", "Adresse", "Téléphone", "Date naissance", "Lieu naissance", "Statut", "Nombre enfants",
          "Religion", "Type contrat", "Date début contrat", "Date fin contrat", "Numéro ligne", "Nom arrêt", "X-Ray", "OJT X-Ray", "Date Certif X-Ray", "Validité Certification",
          "Bagage soute & cabine", "Filtrage pers. & objets", "Filtrage frêt et poste", "Fouille contrôle véhicule", "OJT Base", "Date Certif Base", "Validité OJT Base",
          "MDR", "Date Certif MDR", "Validité OJT MDR", "Formé(e)", "Date Formation", "Validité Formation", "Sensibilisé(e)", "Numéros certification",
          "Autres formations", "Niveau", "Taille agent (cm)", "Taille chemise", "Taille jupe", "Taille pantalon", "Pointure chaussure", "Photo", "Date réelle départ",
          "Raison départ", "Date création"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Matricule", width: "150px"},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom", width: "200px", readOnly: true},
          {title: "Brigade", width: "160px", readOnly: true},
          {
            title: "Genre",
            width: "200px",
            type: 'dropdown',
            source: ["Homme", "Femme"],
            allowInvalid: false,
            strict: true
          },
          {title: "Fonction", width: "200px", readOnly: true},
          {title: "Adresse", width: "200px", readOnly: true},
          {title: "Téléphone", width: "150px", readOnly: true},
          {
            title: "Date naissance",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "Lieu naissance", width: "200px"},
          {
            title: "Statut",
            width: "200px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {title: "Nombre enfants", width: "160px"},
          {title: "Religion", width: "200px"},
          {
            title: "Type contrat",
            width: "200px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Date début contrat",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {
            title: "Date fin contrat",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {
            title: "Numéro de ligne",
            width: "200px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {title: "Nom arrêt", width: "200px"},

          {title: "X-Ray", width: "75px", type: "checkbox"},
          {title: "OJT X-Ray", width: "130px", type: "checkbox"},
          {
            title: "Date Certif X-Ray",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "Validité Certification", width: "200px", type: "checkbox", readOnly: true},

          {title: "Bagage soute & cabine", width: "200px", type: "checkbox"},
          {title: "Filtrage pers. & objets", width: "200px", type: "checkbox"},
          {title: "Filtrage frêt et poste", width: "200px", type: "checkbox"},
          {title: "Fouille contrôle véhicule", width: "200px", type: "checkbox"},
          {title: "OJT Base", width: "130px", type: "checkbox"},
          {
            title: "Date Certif Base",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "Validité OJT Base", width: "200px", type: "checkbox", readOnly: true},

          {title: "MDR", width: "125px", type: "checkbox"},
          {
            title: "Date Certif MDR",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "Validité OJT MDR", width: "200px", type: "checkbox", readOnly: true},

          {title: "Formé(e)", width: "125px", type: "checkbox"},
          {
            title: "Date Formation",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "Validité Formation", width: "200px", type: "checkbox", readOnly: true},

          {title: "Sensibilisé(e)", width: "200px", type: "checkbox"},
          {title: "Numéros certifications", width: "200px"},

          {title: "Autres formations", width: "200px"},
          {
            title: "Niveau",
            width: "200px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },

          {title: "Taille agent (cm)", width: "200px"},
          {title: "Taille chemise", width: "200px"},
          {title: "Taille jupe", width: "200px"},
          {title: "Taille pantalon", width: "200px"},
          {title: "Pointure chaussure", width: "200px"},

          {title: "Photo", width: "100px", renderer: coverRenderer},
          {
            title: "Date réelle départ",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            // Add this to handle empty dates properly
            allowEmpty: true,
            // Add validation
            validator: function(value, callback) {
              if (value === null || value === '' || value === undefined) {
                callback(true); // Allow empty values
              } else {
                // Validate date format
                const isValidDate = moment(value, "DD-MM-YYYY", true).isValid();
                callback(isValidDate);
              }
            }
          },
          {
            title: "Raison départ",
            width: "200px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: false,
            // Add this to ensure the source is set properly
            trimDropdown: false,
            source: function() {
              return JSON.parse(sessionStorage.getItem("ReasonsLeave")) || [];
            },
            // Add validation
            validator: function(value, callback) {
              if (value === null || value === '' || value === undefined) {
                callback(true); // Allow empty values
              } else {
                const validOptions = JSON.parse(sessionStorage.getItem("ReasonsLeave")) || [];
                callback(validOptions.includes(value));
              }
            }
          },
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
        ],
        cells: function (row, col) {
          const cellPrp = {};
          if (col === 45) {
            cellPrp.renderer = coverRenderer;
            cellPrp.readOnly = true;
          }
          return cellPrp
        },
        afterSelection: function(row, column, row2, column2, preventScrolling, selectionLayerLevel) {
          // Remove aria-hidden from focused elements
          setTimeout(() => {
            const activeElement = document.activeElement;
            if (activeElement && activeElement.classList.contains('handsontableInput')) {
              if (activeElement.getAttribute('aria-hidden') === 'true') {
                activeElement.removeAttribute('aria-hidden');
              }
            }
          }, 0);
        },
        afterRender: function() {
          // Corriger tous les éléments input problématiques
          setTimeout(() => {
            const inputs = document.querySelectorAll('.handsontableInput[tabindex="-1"]');
            inputs.forEach(input => {
              // Si l'élément a le focus, on ne peut pas avoir aria-hidden="true"
              if (input === document.activeElement) {
                input.removeAttribute('aria-hidden');
              }
            });
          }, 0);
        },

        afterBeginEditing: function(row, column) {
          // Quand l'édition commence, corriger immédiatement l'input actif
          setTimeout(() => {
            const activeInput = document.activeElement;
            if (activeInput && activeInput.classList.contains('handsontableInput')) {
              activeInput.removeAttribute('aria-hidden');
              // Optionnel: améliorer l'accessibilité
              activeInput.setAttribute('tabindex', '0');
            }
          }, 0);
        },

        beforeKeyDown: function(event) {
          // Avant chaque frappe, s'assurer que l'input actif n'a pas aria-hidden
          setTimeout(() => {
            const activeInput = document.activeElement;
            if (activeInput && activeInput.classList.contains('handsontableInput')) {
              activeInput.removeAttribute('aria-hidden');
            }
          }, 0);
        },

        afterSelectionEnd: function(row, column, row2, column2) {
          // Après sélection, nettoyer les attributs ARIA problématiques
          setTimeout(() => {
            const focusedInput = document.querySelector('.handsontableInput:focus');
            if (focusedInput) {
              focusedInput.removeAttribute('aria-hidden');
            }
          }, 10);
        },
      }
    }
  },
  created() {
    this.getData()
    this.loadStatus()
    this.loadTypesContract()
    this.loadreasonsLeave()
    this.loadBusLines()
    this.loadLevels()
  },
  mounted() {
    window.show = this.show;
    window.displayTitleModif = this.displayTitleModif;
    window.updateData4Modif = this.updateData4Modif;

    this.setupAriaFix();
  },
  computed: {
    FormIsValid() {
      return (
          this.editedItem.userId !== "" &&
          this.editedItem.genre !== ""
      );
    },
    userRole() {
      return this.$store.getters.user.role;
    },
    computedDateFormatted() {
      return this.formatDate(this.editedItem.birthdayDate)
    },
    computedDateFormattedSCD() {
      return this.formatDate(this.editedItem.startContractDate)
    },
    computedDateFormattedECD() {
      return this.formatDate(this.editedItem.endContractDate)
    },
    computedDateFormattedDRD() {
      return this.formatDate(this.editedItem.dateRealLeft)
    },
    computedDateFormattedXRay() {
      return this.formatDate(this.editedItem.dateCertifXRay)
    },
    computedDateFormattedBase() {
      return this.formatDate(this.editedItem.dateCertifBase)
    },
    computedDateFormattedMDR() {
      return this.formatDate(this.editedItem.dateMDR)
    },
    computedDateFormattedFormed() {
      return this.formatDate(this.editedItem.dateFormed)
    },
  },
  methods: {
    /*launchDetailsDialog() {
                //Execute code
                this.dialog = true
                alert ("Hello")
            },*/
    displayTitleModif(row) {
      String.prototype.capitalize = function (allWords) {
        return (allWords) ? // if all words
            this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
            this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
      }

      let rowT = this.$refs.hotTable.hotInstance.getData()[row]
      this.modifier = "Modifications détails agent " + rowT[2].toUpperCase() + " " + rowT[3].toLowerCase().capitalize(true);
    },
    updateData4Modif(row) {
      String.prototype.capitalize = function (allWords) {
        return (allWords) ? // if all words
            this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
            this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
      }

      this.bCertifications = [];
      let rowT = this.$refs.hotTable.hotInstance.getData()[row]

      this.editedItem.id = rowT[0];
      this.editedItem.userId = rowT[1];
      this.editedItem.accountLastname = rowT[2].toUpperCase();
      this.editedItem.accountFirstname = rowT[3].toLowerCase().capitalize(true);
      //this.editedItem.brigade = rowT[4]; La brigade n'est pas saisie
      this.editedItem.genre = rowT[5].toLowerCase().capitalize(true);
      this.editedItem.fonction = rowT[6].toUpperCase();
      this.editedItem.accountAddress = rowT[7];
      this.editedItem.accountPhonenumber = rowT[8];
      this.editedItem.birthdayDate = !this.isEmpty(rowT[9]) ? moment(rowT[9], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      this.editedItem.birthdayPlace = rowT[10].toLowerCase().capitalize(true);
      this.editedItem.status = rowT[11];
      this.editedItem.nbrEnfants = rowT[12];
      this.editedItem.religion = rowT[13].toLowerCase().capitalize(true);
      this.editedItem.typecontract = rowT[14];
      this.editedItem.startContractDate = !this.isEmpty(rowT[15]) ? moment(rowT[15], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      this.editedItem.endContractDate = !this.isEmpty(rowT[16]) ? moment(rowT[16], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      this.editedItem.busline = rowT[17];
      this.editedItem.busStop = rowT[18];
      this.editedItem.imgRadio = (rowT[19] === true) ? this.bCertifications.push("xray") : null;
      this.editedItem.ojtimgRadio = (rowT[20] === true) ? this.bCertifications.push("oxray") : null;
      this.editedItem.dateCertifXRay = !this.isEmpty(rowT[21]) ? moment(rowT[21], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      //this.editedItem.imgRadioCertifStillValid = (rowT[19]===true)?this.bCertifications.push("xray"):null; // Pas saisie
      this.editedItem.bbgSouteCab = (rowT[23] === true) ? this.bCertifications.push("bsc") : null;
      this.editedItem.filtrePersObj = (rowT[24] === true) ? this.bCertifications.push("fpo") : null;
      this.editedItem.filtreFretPoste = (rowT[25] === true) ? this.bCertifications.push("ffp") : null;
      this.editedItem.fouilleCtrlVeh = (rowT[26] === true) ? this.bCertifications.push("fcv") : null;
      this.editedItem.ojtbase = (rowT[27] === true) ? this.bCertifications.push("obase") : null;
      this.editedItem.dateCertifBase = !this.isEmpty(rowT[28]) ? moment(rowT[28], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      //this.editedItem.baseCertifStillValid = rowT[26];
      this.editedItem.mdr = (rowT[30] === true) ? this.bCertifications.push("mdr") : null;
      this.editedItem.dateMDR = !this.isEmpty(rowT[31]) ? moment(rowT[31], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      //this.editedItem.mdrcertifStillValid = rowT[29];
      this.editedItem.formed = this.bCertifications.push("f"); //(rowT[33]===true)?this.bCertifications.push("f"):null;
      this.editedItem.dateFormed = !this.isEmpty(rowT[34]) ? moment(rowT[34], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      //this.editedItem.formedStillValid = rowT[32];
      this.editedItem.sensitized = this.bCertifications.push("s"); //(rowT[36]===true)?this.bCertifications.push("s"):null;
      this.editedItem.certifications = rowT[37];
      this.editedItem.otherFormations = rowT[38];
      this.editedItem.level = rowT[39];
      this.editedItem.taille = rowT[40];
      this.editedItem.tailleChemise = rowT[41];
      this.editedItem.tailleJupe = rowT[42];
      this.editedItem.taillePantalon = rowT[43];
      this.editedItem.pointure = rowT[44];
      this.editedItem.dateRealLeft = !this.isEmpty(rowT[46]) ? moment(rowT[46], "DD-MM-YYYY").format("YYYY-MM-DD") : null;
      this.editedItem.reasonLeft = rowT[47];
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    init() {
      this.initEditedItem()
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    setupAriaFix() {
      // Observer les changements dans le DOM pour corriger les problèmes ARIA
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            const target = mutation.target;
            if (target.classList.contains('handsontableInput') && target === document.activeElement) {
              target.removeAttribute('aria-hidden');
            }
          }
        });
      });

      // Observer tous les changements d'attributs sur les inputs Handsontable
      const tableContainer = this.$refs.hotTable?.$el || document;
      observer.observe(tableContainer, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'tabindex']
      });

      // Stocker l'observer pour le nettoyer plus tard
      this.ariaObserver = observer;
    },
    beforeDestroy() {
      // Nettoyer l'observer
      if (this.ariaObserver) {
        this.ariaObserver.disconnect();
      }
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/usersdetails/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                this.isEmpty(item["sexe"]) ? "" : item["sexe"].toUpperCase(),
                this.isEmpty(item["userRoles"]) ? "" : item["userRoles"].toUpperCase(),
                item["accountAddress"],
                item["accountPhonenumber"],
                this.convertDate(item["birthday"]),
                this.isEmpty(item["birthdayPlace"]) ? "" : item["birthdayPlace"].toUpperCase(),
                this.isEmpty(item["status"]) ? "" : item["status"],
                this.isEmpty(item["numberChildren"]) ? "" : item["numberChildren"],
                this.isEmpty(item["religion"]) ? "" : item["religion"].toUpperCase(),
                this.isEmpty(item["contractType"]) ? "" : item["contractType"],
                this.convertDate(item["dateStartContract"]),
                this.convertDate(item["dateEndContract"]),
                this.isEmpty(item["busLine"]) ? "" : item["busLine"],
                this.isEmpty(item["busStop"]) ? "" : item["busStop"],
                item["imgRadio"],
                item["ojtimgRadio"],
                this.convertDate(item["dateCertifXRay"]),
                item["imgRadioCertifStillValid"],
                item["bbgSouteCab"],
                item["filtrePersObj"],
                item["filtreFretPoste"],
                item["fouilleCtrlVeh"],
                item["ojtbase"],
                this.convertDate(item["dateCertifBase"]),
                item["baseCertifStillValid"],
                item["mdr"],
                this.convertDate(item["dateMDR"]),
                item["mdrcertifStillValid"],
                item["formed"],
                this.convertDate(item["dateFormed"]),
                item["formedStillValid"],
                item["sensitized"],
                this.isEmpty(item["numerosCertifs"]) ? "" : item["numerosCertifs"].toUpperCase(),
                this.isEmpty(item["otherFormations"]) ? "" : item["otherFormations"].toLowerCase().capitalize(true),
                this.isEmpty(item["level"]) ? "" : item["level"],
                this.isEmpty(item["taille"]) ? "" : item["taille"].toUpperCase(),
                this.isEmpty(item["tailleChemise"]) ? "" : item["tailleChemise"].toUpperCase(),
                this.isEmpty(item["tailleJupe"]) ? "" : item["tailleJupe"].toUpperCase(),
                this.isEmpty(item["taillePantalon"]) ? "" : item["taillePantalon"].toUpperCase(),
                this.isEmpty(item["pointure"]) ? "" : item["pointure"].toUpperCase(),
                this.iconPhoto,
                this.convertDate(item["dateRealLeft"]),
                this.isEmpty(item["reasonLeft"]) ? "" : item["reasonLeft"],
                this.datefull(item["creationDate"])
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            console.log("AccountsDetails 0")
            this.loading = false
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    loadStatus() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/status/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Status", null)
            let datas = response.data.datas;
            datas.forEach(item => {
              this.status.push(item.type);
            });
            sessionStorage.setItem("Status", JSON.stringify(this.status))
          })
          .catch(error => {
            console.log("AccountsDetails 1")
          });
    },
    loadTypesContract() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/typescontract/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Contracts", null)
            let datas = response.data.datas;
            datas.forEach(item => {
              this.typescontract.push(item.type);
            });
            sessionStorage.setItem("Contracts", JSON.stringify(this.typescontract))
          })
          .catch(() => {
          });
    },
    loadreasonsLeave() {
      console.log('Loading reasons leave...'); // Debug
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/reasonsleave/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            console.log('Reasons leave response:', response.data); // Debug

            // Vider d'abord
            this.reasonsleave = [];
            sessionStorage.removeItem("ReasonsLeave");

            let datas = response.data.datas;
            datas.forEach(item => {
              // Vérifiez si c'est item.raison ou item.type dans votre API
              this.reasonsleave.push(item.raison);
            });

            console.log('Final reasonsleave array:', this.reasonsleave); // Debug
            sessionStorage.setItem("ReasonsLeave", JSON.stringify(this.reasonsleave));
          })
          .catch((error) => {
            console.log('Error loading reasons leave:', error);
            // Mettre des données de test pour voir si ça marche
            const testData = ["Démission", "Fin de contrat", "Décès", "Renvoyé"];
            sessionStorage.setItem("ReasonsLeave", JSON.stringify(testData));
          });
    },
    loadBusLines() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/buslines/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("BusLines", null)
            let datas = response.data.datas;
            datas.forEach(item => {
              this.buslines.push(item.busLine);
            });
            sessionStorage.setItem("BusLines", JSON.stringify(this.buslines))
          })
          .catch(() => {
          });
    },
    loadLevels() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/levels/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Levels", null)
            let datas = response.data.datas;
            datas.forEach(item => {
              this.levels.push(item.type);
            });
            sessionStorage.setItem("Levels", JSON.stringify(this.levels))
          })
          .catch(() => {
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      if (this.isEmpty(val) || (val === null)) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.initEditedItem();
      this.bCertifications = [];
      this.dialog = false;
      this.dialog2 = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertS(type) {
      this.typeS = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.hide()
        }
        this.typeS = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    show() {
      //this.$modal.show('modal-fade');
      this.dialog2 = true;
    },
    hide() {
      this.dialog2 = false;
      //this.$modal.hide('modal-fade');
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterOnCellMouseDownMe(event, coords) {
      if (coords.col !== 45) {
        return;
      }

      let myData = this.$refs.hotTable.hotInstance.getData();
      let name = myData[coords.row][1] + ".png"
      let path = "@/assets/PHOTOS_MATRICULES/"
      let fullpath = path + name

      //this.namePhoto = fullpath
      //this.namePhoto = require(`../../assets/2.png`)
      this.namePhoto = myData[coords.row][1] + ".png"
      this.dialogTmp = true;
    },
    getImgUrl(userId) {
      if (userId === "")
        return;
      return require('@/assets/PHOTOS_MATRICULES/' + userId)
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification des détails du compte.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.initEditedItem();
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              let sdtBirthday = moment(obj[9], "DD-MM-YYYY").format("YYYY-MM-DD")
              let sdtStartContract = moment(obj[15], "DD-MM-YYYY").format("YYYY-MM-DD")
              let sdtEndContract = moment(obj[16], "DD-MM-YYYY").format("YYYY-MM-DD")
              let sdtRealLeft = moment(obj[46], "DD-MM-YYYY").format("YYYY-MM-DD")

              let dateCertifXRay = moment(obj[21], "DD-MM-YYYY").format("YYYY-MM-DD")
              let dateCertifBase = moment(obj[28], "DD-MM-YYYY").format("YYYY-MM-DD")
              let dateMDR = moment(obj[30], "DD-MM-YYYY").format("YYYY-MM-DD")
              let dateFormed = moment(obj[34], "DD-MM-YYYY").format("YYYY-MM-DD")

              /*                                    if ((sdtBirthday === "Invalid date") || (sdtStartContract === "Invalid date") || (sdtEndContract === "Invalid date") || (sdtRealLeft === "Invalid date")) {
                                                                    this.text = "Date & Heure invalide -> Ligne " + (changes[0][0] + 1) +
                                                                        ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

                                                                    this.showAlert('warning')
                                                                    this.loading = false
                                                                    this.refresh()
                                                                    return;
                                                                }*/

              newObj = {
                "id": obj[0],
                "userId": obj[1],
                "accountLastname": obj[2],
                "accountFirstname": obj[3],
                "brigade": obj[4],
                "sexe": obj[5],
                "userRoles": obj[6],
                "accountAddress": obj[7],
                "accountPhonenumber": obj[8],
                "birthday": (sdtBirthday === "Invalid date") ? null : sdtBirthday,
                "birthdayPlace": obj[10],
                "status": obj[11],
                "numberChildren": obj[12],
                "religion": obj[13],
                "contractType": obj[14],
                "dateStartContract": (sdtStartContract === "Invalid date") ? null : sdtStartContract,
                "dateEndContract": (sdtEndContract === "Invalid date") ? null : sdtEndContract,
                "busLine": obj[17],
                "busStop": obj[18],
                "imgRadio": obj[19],
                "ojtimgRadio": obj[20],
                "dateCertifXRay": (dateCertifXRay === "Invalid date") ? null : dateCertifXRay,
                "imgRadioCertifStillValid": obj[22],
                "bbgSouteCab": obj[23],
                "filtrePersObj": obj[24],
                "filtreFretPoste": obj[25],
                "fouilleCtrlVeh": obj[26],
                "ojtbase": obj[27],
                "dateCertifBase": (dateCertifBase === "Invalid date") ? null : dateCertifBase,
                "baseCertifStillValid": obj[29],
                "mdr": obj[30],
                "dateMDR": (dateMDR === "Invalid date") ? null : dateMDR,
                "mdrcertifStillValid": obj[32],
                "formed": true, //obj[33],
                "dateFormed": (dateFormed === "Invalid date") ? null : dateFormed,
                "formedStillValid": obj[35],
                "sensitized": true, //obj[36],
                "numerosCertifs": obj[37],
                "otherFormations": obj[38],
                "level": obj[39],
                "taille": obj[40],
                "tailleChemise": obj[41],
                "tailleJupe": obj[42],
                "taillePantalon": obj[43],
                "pointure": obj[44],
                "dateRealLeft": (sdtRealLeft === "Invalid date") ? null : sdtRealLeft,
                "reasonLeft": obj[47],
                "revisedUser": sessionStorage.getItem("userId")
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/account/userdetails/` + sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.getData()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.alert = true
                      this.text = res.data.message;
                      this.dialog = false;

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression des details du compte.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/userdetails/` + rowId[0] + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 22, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 29, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 32, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 35, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 48, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 22, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 29, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 32, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 35, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 48, "readOnly", false);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 22, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 29, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 32, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 35, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 48, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 22, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 29, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 32, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 35, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 48, "readOnly", false);
          });
    },
    initEditedItem() {
      this.editedItem.id =
          this.editedItem.userId =
              this.editedItem.accountLastname =
                  this.editedItem.accountFirstname =
                      this.editedItem.fonction =
                          this.editedItem.accountAddress =
                              this.editedItem.accountPhonenumber =
                                  this.editedItem.brigade =
                                      this.editedItem.genre =
                                          this.editedItem.birthdayDate =
                                              this.editedItem.birthdayPlace =
                                                  this.editedItem.status =
                                                      this.editedItem.nbrEnfants =
                                                          this.editedItem.religion =
                                                              this.editedItem.typecontract =
                                                                  this.editedItem.startContractDate =
                                                                      this.editedItem.endContractDate =
                                                                          this.editedItem.busline =
                                                                              this.editedItem.busStop =
                                                                                  this.editedItem.imgRadio =
                                                                                      this.editedItem.ojtimgRadio =
                                                                                          this.editedItem.dateCertifXRay =
                                                                                              this.editedItem.imgRadioCertifStillValid =
                                                                                                  this.editedItem.bbgSouteCab =
                                                                                                      this.editedItem.filtrePersObj =
                                                                                                          this.editedItem.filtreFretPoste =
                                                                                                              this.editedItem.fouilleCtrlVeh =
                                                                                                                  this.editedItem.ojtbase =
                                                                                                                      this.editedItem.dateCertifBase =
                                                                                                                          this.editedItem.baseCertifStillValid =
                                                                                                                              this.editedItem.mdr =
                                                                                                                                  this.editedItem.dateMDR =
                                                                                                                                      this.editedItem.mdrcertifStillValid =
                                                                                                                                          this.editedItem.formed =
                                                                                                                                              this.editedItem.dateFormed =
                                                                                                                                                  this.editedItem.formedStillValid =
                                                                                                                                                      this.editedItem.sensitized =
                                                                                                                                                          this.editedItem.numerosCertifs =
                                                                                                                                                              this.editedItem.otherFormations =
                                                                                                                                                                  this.editedItem.level =
                                                                                                                                                                      this.editedItem.taille =
                                                                                                                                                                          this.editedItem.tailleChemise =
                                                                                                                                                                              this.editedItem.tailleJupe =
                                                                                                                                                                                  this.editedItem.taillePantalon =
                                                                                                                                                                                      this.editedItem.pointure =
                                                                                                                                                                                          this.editedItem.dateRealLeft =
                                                                                                                                                                                              this.editedItem.reasonLeft = "";


      this.bCertifications = [];
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    creer() {
      this.loading = true
      const dataToSave = {
        id: this.isEmpty(this.editedItem.id) ? 0 : this.editedItem.id,
        userId: this.editedItem.userId,
        sexe: this.editedItem.genre,
        status: this.editedItem.status,
        numberChildren: this.editedItem.nbrEnfants,
        religion: this.editedItem.religion,
        contractType: this.editedItem.typecontract,
        busLine: this.editedItem.busline,
        busStop: this.editedItem.busStop,
        level: this.editedItem.level,
        birthday: this.editedItem.birthdayDate,
        imgRadio: this.bCertifications.includes("xray"),
        ojtimgRadio: this.bCertifications.includes("oxray"),
        bbgSouteCab: this.bCertifications.includes("bsc"),
        filtrePersObj: this.bCertifications.includes("fpo"),
        filtreFretPoste: this.bCertifications.includes("ffp"),
        fouilleCtrlVeh: this.bCertifications.includes("fcv"),
        ojtbase: this.bCertifications.includes("obase"),
        formed: true, //this.bCertifications.includes("f"),
        sensitized: true, //this.bCertifications.includes("s"),
        mdr: this.bCertifications.includes("mdr"),
        dateCertifXRay: this.editedItem.dateCertifXRay,
        dateCertifBase: this.editedItem.dateCertifBase,
        dateMDR: this.editedItem.dateMDR,
        dateFormed: this.editedItem.dateFormed,
        dateStartContract: this.editedItem.startContractDate,
        otherFormations: this.editedItem.otherFormations,
        dateEndContract: this.editedItem.endContractDate,
        numerosCertifs: this.editedItem.certifications,
        birthdayPlace: this.editedItem.birthdayPlace,
        reasonLeft: this.editedItem.reasonLeft,
        dateRealLeft: this.editedItem.dateRealLeft,
        taille: this.editedItem.taille,
        tailleChemise: this.editedItem.taillePantalon,
        tailleJupe: this.editedItem.tailleJupe,
        taillePantalon: this.editedItem.taillePantalon,
        pointure: this.editedItem.pointure
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/userdetails/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message;
              this.dialog = false;
              if (!this.isEmpty(this.editedItem.id)) {
                this.hide();
              }
              this.getData()
              this.showAlert('info')
              this.initEditedItem()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.text = res.data.message;
              this.dialog = false;
              if (!this.isEmpty(this.editedItem.id))
                this.showAlertS('warning')
              else
                this.showAlert('warning')
            }
          })
          .catch(err => {
            this.alert = true
            this.text = err;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            if (!this.isEmpty(this.editedItem.id))
              this.showAlertS('warning')
            else
              this.showAlert('warning')
          });
    },
    RemoveAccents(sAccents) {
      var strAccents = sAccents.split('');
      var strAccentsOut = [];
      var strAccentsLen = strAccents.length;
      var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
      var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) !== -1) {
          strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else {
          strAccentsOut[y] = strAccents[y];
        }
      }
      strAccentsOut = strAccentsOut.join('');
      return strAccentsOut;
    },
    isInt(value) {
      var x = parseFloat(value);
      return !isNaN(value) && (x | 0) === x;
    },
    importFileToHandsonTable() {
      const vm = this;
      vm.loading = true
      vm.dialog = false;
      vm.file = ""
      let dataTosave = [];

      const fromExcelDate = require('js-excel-date-convert').fromExcelDate;

      let genre = ["homme", "femme"]
      let statut = ["marie", "celibataire", "divorce", "veuf"]
      let contrat = ["cdd", "cdi", "prestataire", "stagiaire"]
      let niveau = ["debutant", "intermediaire", "confirme", "expert"]
      let raisonDepart = ["demission", "fin de contrat", "Deces", "renvoye"]

      let sdtBirthday = null, sdtStartContract = null, sdtEndContract = null, sdtDateOJTXRay = null,
          sdtDateOJTBase = null, sdtOJTMDR = null, sdtFormation = null, sdtReelDepart = null

      for (let i = 0; i < this.excelData.length; i++) {
        if (!this.isEmpty(this.excelData[i][2])) {
          sdtBirthday = moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD")
          if (sdtBirthday === "Invalid date") {
            this.text = "Date & Heure invalide (Date de Naissance) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][8])) {
          sdtStartContract = moment(fromExcelDate(this.excelData[i][8])).format("YYYY-MM-DD")
          if (sdtStartContract === "Invalid date") {
            this.text = "Date & Heure invalide (Date début contrat) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][9])) {
          sdtEndContract = moment(fromExcelDate(this.excelData[i][9])).format("YYYY-MM-DD")
          if (sdtEndContract === "Invalid date") {
            this.text = "Date & Heure invalide (Date fin contrat) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][14])) {
          sdtDateOJTXRay = moment(fromExcelDate(this.excelData[i][14])).format("YYYY-MM-DD")
          if (sdtDateOJTXRay === "Invalid date") {
            this.text = "Date & Heure invalide (Date Certif X-Ray) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][20])) {
          sdtDateOJTBase = moment(fromExcelDate(this.excelData[i][20])).format("YYYY-MM-DD")
          if (sdtDateOJTBase === "Invalid date") {
            this.text = "Date & Heure invalide (Date Certif Base) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][22])) {
          sdtOJTMDR = moment(fromExcelDate(this.excelData[i][22])).format("YYYY-MM-DD")
          if (sdtOJTMDR === "Invalid date") {
            this.text = "Date & Heure invalide (Date Certif MDR) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][24])) {
          sdtFormation = moment(fromExcelDate(this.excelData[i][24])).format("YYYY-MM-DD")
          if (sdtFormation === "Invalid date") {
            this.text = "Date & Heure invalide (Date Formation) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][34])) {
          sdtReelDepart = moment(fromExcelDate(this.excelData[i][34])).format("YYYY-MM-DD")
          if (sdtReelDepart === "Invalid date") {
            this.text = "Date & Heure invalide (Date réelle départ) -> Ligne " + (i + 2) +
                ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

            this.showAlert('warning')
            this.loading = false
            this.refresh()
            return;
          }
        }

        if (!this.isEmpty(this.excelData[i][1]) && !genre.includes(this.RemoveAccents(this.excelData[i][1].trim().toLowerCase()))) {
          this.text = "Genre '" + this.excelData[i][1] + "' inconnu -> Ligne " + (i + 2) + ". Merci de prendre exemple sur le modèle."
          this.showAlert('warning')
          this.loading = false
          this.refresh()
          return;
        }

        if (!this.isEmpty(this.excelData[i][4]) && !statut.includes(this.RemoveAccents(this.excelData[i][4].trim().toLowerCase()))) {
          this.text = "Statut '" + this.excelData[i][4] + "' inconnu -> Ligne " + (i + 2) + ". Merci de prendre exemple sur le modèle."
          this.showAlert('warning')
          this.loading = false
          this.refresh()
          return;
        }

        if (!this.isEmpty(this.excelData[i][7]) && !contrat.includes(this.RemoveAccents(this.excelData[i][9].trim().toLowerCase()))) {
          this.text = "Type de contrat '" + this.excelData[i][7] + "' inconnu -> Ligne " + (i + 2) + ". Merci de prendre exemple sur le modèle."
          this.showAlert('warning')
          this.loading = false
          this.refresh()
          return;
        }

        if (!this.isEmpty(this.excelData[i][28]) && !niveau.includes(this.RemoveAccents(this.excelData[i][22].trim().toLowerCase()))) {
          this.text = "Niveau '" + this.excelData[i][28] + "' inconnu -> Ligne " + (i + 2) + ". Merci de prendre exemple sur le modèle."
          this.showAlert('warning')
          this.loading = false
          this.refresh()
          return;
        }

        if (!this.isEmpty(this.excelData[i][28]) && !raisonDepart.includes(this.RemoveAccents(this.excelData[i][28].trim().toLowerCase()))) {
          this.text = "Raison départ '" + this.excelData[i][28] + "' inconnu -> Ligne " + (i + 2) + ". Merci de prendre exemple sur le modèle."
          this.showAlert('warning')
          this.loading = false
          this.refresh()
          return;
        }

        let suserId = this.excelData[i][0];
        let ssexe = this.excelData[i][1];
        let sbirthday = sdtBirthday;
        let sbirthdayPlace = this.excelData[i][3];
        let sstatus = this.excelData[i][4];
        let snumberChildren = this.excelData[i][5];
        let sreligion = this.excelData[i][6];
        let scontractType = this.excelData[i][7];
        let sdateStartContract = sdtStartContract;
        let sdateEndContract = sdtEndContract;
        let sbusLine = this.excelData[i][10];
        let sbusStop = this.excelData[i][11];
        let simgRadio = this.excelData[i][12];
        let sojtimgRadio = this.excelData[i][13];
        let sdateCertifXRay = sdtDateOJTXRay;
        let sbbgSouteCab = this.excelData[i][15];
        let sfiltrePersObj = this.excelData[i][16];
        let sfiltreFretPoste = this.excelData[i][17];
        let sfouilleCtrlVeh = this.excelData[i][18];
        let sojtbase = this.excelData[i][19];
        let sdateCertifBase = sdtDateOJTBase;
        let smdr = this.excelData[i][21];
        let sdateMDR = sdtOJTMDR;
        let sformed = this.excelData[i][23];
        let sdateFormed = sdtFormation;
        let ssensitized = this.excelData[i][25];
        let snumerosCertifs = this.excelData[i][26];
        let sotherFormations = this.excelData[i][27];
        let slevel = this.excelData[i][28];
        let staille = this.excelData[i][29];
        let stailleChemise = this.excelData[i][30];
        let stailleJupe = this.excelData[i][31];
        let staillePantalon = this.excelData[i][32];
        let spointure = this.excelData[i][33];
        let sreasonLeft = this.excelData[i][34];
        let sdateRealLeft = sdtReelDepart;

        dataTosave.push({
          userId: this.isInt(suserId) ? suserId : suserId.trim(),
          sexe: this.isInt(ssexe) ? ssexe : ssexe.trim(),
          birthday: sbirthday,
          birthdayPlace: this.isInt(sbirthdayPlace) ? sbirthdayPlace : sbirthdayPlace.trim(),
          status: this.isInt(sstatus) ? sstatus : sstatus.trim(),
          numberChildren: this.isInt(snumberChildren) ? snumberChildren : snumberChildren.trim(),
          religion: this.isInt(sreligion) ? sreligion : sreligion.trim(),
          contractType: this.isInt(scontractType) ? scontractType : scontractType.trim(),
          dateStartContract: sdtStartContract,
          dateEndContract: sdtEndContract,
          busLine: this.isInt(sbusLine) ? sbusLine : sbusLine.trim(),
          busStop: this.isInt(sbusStop) ? sbusStop : sbusStop.trim(),
          imgRadio: simgRadio === 1,
          ojtimgRadio: sojtimgRadio === 1,
          dateCertifXRay: sdateCertifXRay,
          bbgSouteCab: sbbgSouteCab === 1,
          filtrePersObj: sfiltrePersObj === 1,
          filtreFretPoste: sfiltreFretPoste === 1,
          fouilleCtrlVeh: sfouilleCtrlVeh === 1,
          ojtbase: sojtbase === 1,
          dateCertifBase: sdateCertifBase,
          mdr: this.isInt(smdr) ? smdr : smdr.trim(),
          dateMDR: sdateMDR,
          formed: sformed === 1,
          dateFormed: sdateFormed,
          sensitized: ssensitized === 1,
          numerosCertifs: this.isInt(snumerosCertifs) ? snumerosCertifs : snumerosCertifs.trim(),
          otherFormations: this.isInt(sotherFormations) ? sotherFormations : sotherFormations.trim(),
          level: this.isInt(slevel) ? slevel : slevel.trim(),
          taille: this.isInt(staille) ? staille : staille.trim(),
          tailleChemise: this.isInt(stailleChemise) ? stailleChemise : stailleChemise.trim(),
          tailleJupe: this.isInt(stailleJupe) ? stailleJupe : stailleJupe.trim(),
          taillePantalon: this.isInt(staillePantalon) ? staillePantalon : staillePantalon.trim(),
          pointure: this.isInt(spointure) ? spointure : spointure.trim(),
          reasonLeft: this.isInt(sreasonLeft) ? sreasonLeft : sreasonLeft.trim(),
          dateRealLeft: sdateRealLeft,
          originUser: sessionStorage.getItem("userId")
        });
      }

      apiClient
          .post(
              `${vm.$store.getters.user.baseUrl}/account/usersdetails/` +
              sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            vm.loading = false
            if (res.data.status === 200) {
              let dataObj = []
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                vm.color = "#009688"
                vm.text = dataObj.length + " Détail(s) Agent(s) ajouté(s)."
                vm.file = "";
                this.showAlert('info')
                this.getData()
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                this.getData()
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
                this.getData()
              }
            }
          })
          .catch(err => {
            console.log("AccountsDetails 2")
            vm.alert = true
            vm.text = err;
            vm.loading = false;
            vm.dialog = false;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true

      let toObjectFinal = []

      toObjectFinal.push(
          [
            "Matricule",
            "Nom",
            "Prénoms",
            "Brigade",
            "Genre",
            "Statut",
            "Fonction",
            "X-Ray",
            "Base",
            "Formé(e)",
            "Numeros Certifs",
            "Adresse",
            "Téléphone",
            "Type contrat",
            "Date début contrat",
            "Date fin contrat",
            "Numéro bus",
            "Arrêt bus",
            "Date départ réel",
            "Raison départ"
          ]
      )

      for (let i = 1; i < this.toObject.length; i++) {
        toObjectFinal.push([
          this.toObject[i][1],
          this.toObject[i][2],
          this.toObject[i][3],
          this.toObject[i][4],
          this.toObject[i][5],
          this.toObject[i][11],
          this.toObject[i][6],
          (this.toObject[i][19] === true) ? "X-Ray" : null,
          (this.toObject[i][23] === true || this.toObject[i][24] === true || this.toObject[i][25] === true || this.toObject[i][26] === true) ? "Base" : null,
          (this.toObject[i][33] === true) ? "Formé(e)" : null,
          (this.toObject[i][37]).replace(/\s+/g, ''),
          this.toObject[i][7],
          this.toObject[i][8],
          this.toObject[i][14],
          this.toObject[i][15],
          this.toObject[i][16],
          this.toObject[i][17],
          this.toObject[i][18],
          this.toObject[i][46],
          this.toObject[i][47]
        ])
      }

      const datas = XLSX.utils.json_to_sheet(toObjectFinal, {skipHeader: true});
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Agents_détails") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Agents_détails.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    onexportModele() { // On Click Excel download button
      this.loading = true

      var ws = XLSX.utils.json_to_sheet([
        {
          userId: "Matricule",
          sexe: "Genre",
          birthday: "Date naissance",
          birthdayPlace: "Lieu naissance",
          status: "Statut",
          numberChildren: "Nombre enfants",
          religion: "Religion",
          contractType: "Type contrat",
          dateStartContract: "Date début contrat",
          dateEndContract: "Date fin contrat",
          busLine: "Numéro ligne",
          busStop: "Nom arrêt",
          imgRadio: "X-Ray",
          ojtimgRadio: "OJT X-Ray",
          dateCertifXRay: "Date Certif X-Ray",
          bbgSouteCab: "Bagage soute & cabine",
          filtrePersObj: "Filtrage pers. & objets",
          filtreFretPoste: "Filtrage frêt et poste",
          fouilleCtrlVeh: "Fouille contrôle véhicule",
          ojtbase: "OJT Base",
          dateCertifBase: "Date Certif Base",
          mdr: "MDR",
          dateMDR: "Date Certif MDR",
          formed: "Formé(e)",
          dateFormed: "Date Formation",
          sensitized: "Sensibilisé(e)",
          numerosCertifs: "Numéros certification",
          otherFormations: "Autres formations",
          level: "Niveau",
          taille: "Taille agent (cm)",
          tailleChemise: "Taille chemise",
          tailleJupe: "Taille jupe",
          taillePantalon: "Taille pantalon",
          pointure: "Pointure chaussure",
          reasonLeft: "Raison départ",
          dateRealLeft: "Date réelle départ"
        },
        {
          userId: "12345",
          sexe: "Homme - Femme",
          birthday: "27-03-1976",
          birthdayPlace: "Ouakam (Sénégal)",
          status: "Marié - Célibataire - Divorcé - Veuf",
          numberChildren: "2",
          religion: "Athée",
          contractType: "CDD - CDI - Prestataire - Stagiaire",
          dateStartContract: "20-04-2021",
          dateEndContract: "20-04-2023",
          busLine: "LIGNE 1 - OUAKAM / LIGNE 2 - OBELISQUE - LIGNE 3 - PARCELLES / LIGNE 4 - NATIONALE / LIGNE 5 - THIES / LIGNE 6 - KEUR MASSAR / LIGNE 7 - MBOUR",
          busStop: "Karack Baobab",
          imgRadio: "1 - 0",
          ojtimgRadio: "1 - 0",
          dateCertifXRay: "20-04-2020",
          bbgSouteCab: "1 - 0",
          filtrePersObj: "1 - 0",
          filtreFretPoste: "1 - 0",
          fouilleCtrlVeh: "1 - 0",
          ojtbase: "1 - 0",
          dateCertifBase: "20-01-2020",
          mdr: "1 - 0",
          dateMDR: "20-02-2020",
          formed: "1 - 0",
          dateFormed: "20-11-2019",
          sensitized: "1 - 0",
          numerosCertifs: "12345 - 67890",
          otherFormations: "Assurance Qualité",
          level: "Débutant - Intermédiaire - Confirmé - Expert",
          taille: "175",
          tailleChemise: "37C",
          tailleJupe: "50A",
          taillePantalon: "42L",
          pointure: "39",
          reasonLeft: "Démission - Fin de contrat - Décès - Renvoyé",
          dateRealLeft: "20-07-2021"
        },
      ], {
        header: ["userId", "sexe", "birthday", "birthdayPlace", "status", "numberChildren", "religion", "contractType", "dateStartContract", "dateEndContract",
          "busLine", "busStop", "imgRadio", "ojtimgRadio", "dateCertifXRay", "bbgSouteCab", "filtrePersObj", "filtreFretPoste", "fouilleCtrlVeh", "ojtbase",
          "dateCertifBase", "mdr", "dateMDR", "formed", "dateFormed", "sensitized", "numerosCertifs", "otherFormations", "level", "taille", "tailleChemise",
          "tailleJupe", "taillePantalon", "pointure", "reasonLeft", "dateRealLeft"],
        skipHeader: true,
        cellDates: true
      });

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ws, "Agents_détails_Modèle") // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, "Agents_détails_Modèle.xlsx", {cellDates: true}) // name of the file is "book.xlsx"
      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>